import * as React from "react";
import styles from "../../../../styles/styles";
import styled from "styled-components";

interface Props {
    onClick: () => void;
    ariaExpanded?: boolean;
    fullWidth?: boolean;
    className?: string;
}

const StyledButton = styled.button<{ fullWidth?: boolean }>`
    padding: 0;
    border: 0;
    background: none;
    font-size: 20px;
    color: ${styles.colors.grey7};
    ${({ fullWidth }) => fullWidth && "width: 100%;"}

    &:focus {
        outline: 2px solid ${styles.colors.focusBorderColor};
    }

    &:active {
        color: ${styles.colors.grey8};
    }
`;

class DropdownToggle extends React.Component<React.PropsWithChildren<Props>> {
    public render() {
        return (
            <StyledButton
                type="button"
                onClick={this.props.onClick}
                aria-expanded={this.props.ariaExpanded}
                fullWidth={this.props.fullWidth}
                className={this.props.className}
            >
                {this.props.children}
            </StyledButton>
        );
    }
}

export default DropdownToggle;
